(function (angular) {
    'use strict';

    angular.module('chat2')

        /**
         *
         */
        .factory('chatAdminService', ['$http', '$q', 'portalConfig', 'jwtService', 'profilesService', 'profileHelper', '$state', '$uibModal',
            function ($http, $q, portalConfig, jwtService, profilesService, profileHelper, $state, $uibModal) {

                var urlBase = portalConfig.urlBase;
                //  urlBase = "http://localhost:8001";

                //urlBase = "http://localhost:8006";
                var fac = {
                    assign: assign,
                    close: close,
                    create: create,
                    start: start
                };

                return fac;

                /**
                 * Assign a chat
                 * @param {*} apiSpaceId 
                 * @param {*} chatId 
                 * @param {*} assignInfo 
                 */
                function assign(apiSpaceId, chatId, assignInfo) {

                    return $http.put(urlBase + "/apispaces/" + apiSpaceId + "/chats/" + chatId + "/assign", assignInfo)
                        .then(assignComplete)
                        .catch(assignFailed);

                    function assignComplete(response) {
                        return response.data;
                    }

                    function assignFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }
                }

                /**
                 * Close a chat
                 * @param {*} apiSpaceId 
                 * @param {*} chatId 
                 * @param {*} closeInfo 
                 */
                function close(apiSpaceId, chatId, closeInfo) {

                    return $http.put(urlBase + "/apispaces/" + apiSpaceId + "/chats/" + chatId + "/close", closeInfo)
                        .then(closeComplete)
                        .catch(closeFailed);

                    function closeComplete(response) {
                        return response.data;
                    }

                    function closeFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }
                }

                /**
                 * 
                 * @param {*Create a new chat} apiSpaceId 
                 * @param {*} name 
                 * @param {*} description 
                 * @param {*} teamId 
                 * @param {*} channelId 
                 * @param {*} profileId 
                 */
                function create(apiSpaceId, name, description, teamId, channelId, profileId) {

                    var body = {
                        name: name,
                        description: description,
                        teamId: teamId,
                        channelId: channelId,
                        participants: [
                            {
                                id: "PLATFORMUSER\\" + jwtService.payload.sub,
                                role: "agent"
                            },
                            {
                                id: profileId,
                                role: "participant"
                            },
                        ],
                    };

                    return $http.post(urlBase + "/apispaces/" + apiSpaceId + "/chats", body)
                        .then(createComplete)
                        .catch(createFailed);

                    function createComplete(response) {
                        return response.data;
                    }

                    function createFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }
                }

                /**
                 * 
                 * @param {*} apiSpaceId 
                 */
                function start(apiSpaceId) {
                    var modalInstance = $uibModal.open({
                        animation: true,
                        templateUrl: 'components/toolkit/profiles/templates/profileSearchModal.html',
                        controller: 'profileSearchModal',
                        size: "lg",
                        resolve: {
                            buttonInfo: [function () {
                                return {
                                    icon: "location_searching",
                                    text: "Pick",
                                    class: "btn-primary"
                                };
                            }],
                            profileSchema: ['$q', 'profilesService', '$stateParams', 'profileHelper', function ($q, profilesService, $stateParams, profileHelper) {
                                if (profileHelper.getSchema().length) {
                                    return profileHelper.getSchema();
                                }
                                else {
                                    return profilesService.getProfileSchema(apiSpaceId)
                                        .then(function (result) {
                                            return profileHelper.setSchema(result);
                                        }).catch(function (result) {
                                            var deferred = $q.defer();
                                            if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                            return deferred.promise;
                                        });
                                }
                            }],
                        }
                    });

                    return modalInstance.result
                        .then(function (info) {

                            $state.go("main.apiSpace.chat2.chat.start", {
                                pickedApiSpaceId: apiSpaceId,
                                profileId: info.id
                            });

                        });
                }


            }]);

})(window.angular);
